
import { useState } from 'react';
import Button from '../../../components/base/Button';
import MailchimpForm from '../../../components/feature/MailchimpForm';

// Bandera interna para modo prelanzamiento
const MODO_PRELAUNCH = true;

export default function ProgramSection() {
  const handlePreRegisterClick = () => {
    // Abrir el enlace de Skool en una nueva pestaña
    window.open('https://www.skool.com/experiencia-neo-8010', '_blank');
  };

  return (
    <section id="programa" className="py-24 bg-gradient-to-br from-gray-50 to-purple-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-light mb-6 text-gray-900">
            Ecosistema <span className="font-medium text-[#6607a5]">Experiencia NEO</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Únete gratis al prelanzamiento y asegura tu plaza en la comunidad fundadora de transformación personal más esperada del año.
          </p>
        </div>

        {/* NEO 365 - Oferta especial fundadores - Centrada */}
        <div className="max-w-2xl mx-auto mb-16">
          <div className="bg-gradient-to-br from-gray-900 to-[#6607a5] rounded-3xl p-8 shadow-xl text-white relative overflow-hidden">
            <div className="absolute top-0 right-0 bg-gradient-to-l from-yellow-400 to-orange-500 text-gray-900 px-6 py-2 rounded-bl-2xl font-bold text-sm">
              25 PLAZAS FUNDADORAS
            </div>
            
            <div className="mb-6">
              <h3 className="text-3xl font-bold mb-4 text-center">NEO 365</h3>
              <p className="text-gray-200 leading-relaxed mb-6 text-center">
                Acceso total a una mejor versión de tí día a día. La experiencia completa de transformación personal con todos los beneficios exclusivos.
              </p>

              <div className="flex items-center justify-center mb-6">
                <div className="bg-gradient-to-r from-yellow-400/20 to-orange-400/20 px-6 py-3 rounded-full border border-yellow-400/30">
                  <span className="text-xl font-bold text-yellow-400">Acceso Total</span>
                </div>
              </div>

              <div className="bg-gradient-to-r from-green-400/20 to-blue-400/20 rounded-2xl p-4 mb-6 border border-green-400/30">
                <div className="text-center">
                  <div className="font-bold text-green-300 text-lg">OFERTA PRELANZAMIENTO</div>
                  <div className="text-green-200">¡Acceso completo para fundadores!</div>
                  <div className="text-sm text-green-300 mt-1">Solo primeros 25 cupos</div>
                </div>
              </div>
            </div>

            <div className="space-y-3 mb-8">
              <div className="flex items-center">
                <i className="ri-check-line text-yellow-400 text-xl mr-3"></i>
                <span className="text-gray-200">Comunidad de crecimiento personal</span>
              </div>
              <div className="flex items-center">
                <i className="ri-check-line text-yellow-400 text-xl mr-3"></i>
                <span className="text-gray-200">Nuevos Programas de Transformación incluídos</span>
              </div>
              <div className="flex items-center">
                <i className="ri-check-line text-yellow-400 text-xl mr-3"></i>
                <span className="text-gray-200">Webinars en directo sólo para miembros</span>
              </div>
              <div className="flex items-center">
                <i className="ri-check-line text-yellow-400 text-xl mr-3"></i>
                <span className="text-gray-200">Contenido mensual nuevo</span>
              </div>
              <div className="flex items-center">
                <i className="ri-check-line text-yellow-400 text-xl mr-3"></i>
                <span className="text-gray-200">Retos y juegos semanales</span>
              </div>
              <div className="flex items-center bg-gradient-to-r from-yellow-400/10 to-orange-400/10 rounded-xl p-3 border border-yellow-400/20">
                <i className="ri-gift-line text-yellow-400 text-xl mr-3"></i>
                <span className="text-yellow-200 font-bold">BONUS: Programa "Desata tu Potencial"</span>
              </div>
              <div className="flex items-center bg-gradient-to-r from-yellow-400/10 to-orange-400/10 rounded-xl p-3 border border-yellow-400/20">
                <i className="ri-gift-line text-yellow-400 text-xl mr-3"></i>
                <span className="text-yellow-200 font-bold">BONUS: Masterclases exclusivas de temas elegidos por la comunidad</span>
              </div>
              <div className="flex items-center bg-gradient-to-r from-yellow-400/10 to-orange-400/10 rounded-xl p-3 border border-yellow-400/20">
                <i className="ri-gift-line text-yellow-400 text-xl mr-3"></i>
                <span className="text-yellow-200 font-bold">BONUS: Diagnóstico Inicial personal 1:1</span>
              </div>
            </div>

            <Button 
              size="lg" 
              className="w-full bg-gradient-to-r from-yellow-400 to-orange-500 hover:from-orange-500 hover:to-yellow-400 text-gray-900 font-bold shadow-lg whitespace-nowrap text-sm"
              onClick={handlePreRegisterClick}
            >
              <i className="ri-vip-crown-line text-lg mr-1"></i>
              QUIERO FORMAR PARTE
            </Button>

            {/* Valor añadido destacado */}
            <div className="mt-4 text-center">
              <div className="text-yellow-300 text-sm font-medium">
                <i className="ri-gift-line mr-1"></i>
                Quiero mi oferta exclusiva de fundador
              </div>
            </div>

          </div>
        </div>

        {/* Pre-registration CTA - Formulario siempre visible */}
        <div className="text-center">
          <div id="formulario-prelanzamiento" className="bg-gradient-to-r from-purple-100 to-blue-100 rounded-3xl p-8 max-w-4xl mx-auto border border-purple-200">
            
            {/* Formulario siempre visible */}
            <div className="mt-8">
              <MailchimpForm />
            </div>
          </div>
        </div>

        {/* Founders Section */}
        <div className="mt-32">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-light mb-6 text-gray-900">
              Conoce a los
              <span className="block font-medium bg-gradient-to-r from-[#6607a5] to-purple-600 bg-clip-text text-transparent">
                fundadores
              </span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Los visionarios detrás de NEO que han dedicado su vida a la transformación personal y el desarrollo humano.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-5xl mx-auto">
            {/* Adrián Rodríguez */}
            <div className="bg-white rounded-3xl p-10 shadow-xl border border-gray-200 text-center hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2">
              <div className="mb-8">
                <img 
                  src="https://static.readdy.ai/image/eeb6f71c46431ac1fde6cad29ff61ccd/6c36ad49244229aba3035fe2f461725a.png"
                  alt="Adrián Rodríguez"
                  className="w-32 h-32 rounded-full object-cover object-top mx-auto shadow-xl border-4 border-gradient-to-r from-[#6607a5] to-purple-600"
                />
              </div>
              
              <h3 className="text-3xl font-bold text-gray-900 mb-2">Adrián Rodríguez</h3>
              <p className="text-lg text-[#6607a5] font-medium mb-6">CEO y Co-Fundador – Dirección Creativa y Comunidad</p>
              
              <p className="text-gray-600 leading-relaxed mb-8 text-lg">
                Adrián convierte cada aprendizaje en una experiencia que se vive. Desde los 13 años está vinculado al mundo lúdico-deportivo, acompañando a personas de todas las edades en actividades que combinan movimiento, juego y conexión humana.

                Hoy es instructor de salud y bienestar, ayudando a adultos y mayores a cuidar cuerpo y mente con dinámicas accesibles, cercanas y transformadoras. Está formado en Actividades Físicas, Educación Infantil, Coaching Transpersonal y Dirección de Empresa, aunque lo que más le define es su capacidad de integrar el deporte con el desarrollo personal.

                En NEO impulsa la Comunidad y las Experiencias: planifica, produce y sostiene espacios donde las personas se sienten acompañadas, reconectan con su energía y se llevan herramientas claras, aplicables y divertidas para transformar su día a día.
              </p>

              <div className="space-y-4 mb-8">
                <div className="flex items-center justify-center">
                  <i className="ri-medal-line text-[#6607a5] text-xl mr-3"></i>
                  <span className="text-gray-700">+15 años liderando actividades lúdicas y deportivas</span>
                </div>
                <div className="flex items-center justify-center">
                  <i className="ri-group-line text-[#6607a5] text-xl mr-3"></i>
                  <span className="text-gray-700">Instructor de salud y bienestar</span>
                </div>
                <div className="flex items-center justify-center">
                  <i className="ri-award-line text-[#6607a5] text-xl mr-3"></i>
                  <span className="text-gray-700">Coach certificado internacional</span>
                </div>
              </div>

              <div className="flex justify-center space-x-4">
                <a href="https://www.instagram.com/adrian.rodriguez.lopez?igsh=YzBlcGVxcGMxaGp6&utm_source=qr" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-gradient-to-r from-[#6607a5] to-purple-600 rounded-full flex items-center justify-center hover:scale-110 transition-transform cursor-pointer">
                  <i className="ri-instagram-line text-white text-xl"></i>
                </a>
              </div>
            </div>

            {/* Diego Dubois */}
            <div className="bg-white rounded-3xl p-10 shadow-xl border border-gray-200 text-center hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2">
              <div className="mb-8">
                <img 
                  src="https://static.readdy.ai/image/eeb6f71c46431ac1fde6cad29ff61ccd/cea4b5f851b6bde28e4bcecd1ef6b155.png"
                  alt="Diego Dubois"
                  className="w-32 h-32 rounded-full object-cover object-top mx-auto shadow-xl border-4 border-gradient-to-r from-[#6607a5] to-purple-600"
                />
              </div>
              
              <h3 className="text-3xl font-bold text-gray-900 mb-2">Diego Dubois</h3>
              <p className="text-lg text-[#6607a5] font-medium mb-6">CEO y Co-Fundador – Visión Global y Estratégica</p>
              
              <p className="text-gray-600 leading-relaxed mb-8 text-lg">
                Antes de Neo, Diego trabajaba donde cada minuto cuenta: emergencias y primera respuesta. Allí aprendió a priorizar, comunicar con claridad y liderar bajo presión. Como instructor nacional y Coordinador de Emergencias en Cruz Roja, convirtió protocolos complejos en pasos sencillos que cualquiera puede seguir. Hoy trae esa "calma al caos" a NEO: toma la evidencia, la traduce en guías prácticas y cuida que cada programa tenga criterio, seguridad y resultados medibles. Su sello: rigor sin humo, humanidad en cada decisión.
              </p>

              <div className="space-y-4 mb-8">
                <div className="flex items-center justify-center">
                  <i className="ri-brain-line text-[#6607a5] text-xl mr-3"></i>
                  <span className="text-gray-700">Especialidad de Apoyo Psicosocial en Emergencias</span>
                </div>
                <div className="flex items-center justify-center">
                  <i className="ri-rocket-line text-[#6607a5] text-xl mr-3"></i>
                  <span className="text-gray-700">+15 años de experiencia Humanitaria</span>
                </div>
                <div className="flex items-center justify-center">
                  <i className="ri-lightbulb-line text-[#6607a5] text-xl mr-3"></i>
                  <span className="text-gray-700">Coach certificado internacional</span>
                </div>
              </div>

              <div className="flex justify-center space-x-4">
                <a href="https://www.linkedin.com/in/diego-dubois/" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-gradient-to-r from-[#6607a5] to-purple-600 rounded-full flex items-center justify-center hover:scale-110 transition-transform cursor-pointer">
                  <i className="ri-linkedin-fill text-white text-xl"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Mission Statement */}
          <div className="text-center mt-16">
            <div className="bg-gradient-to-br from-[#6607a5]/5 to-purple-600/5 rounded-3xl p-12 max-w-4xl mx-auto border border-[#6607a5]/20">
              <h3 className="text-3xl font-light text-gray-900 mb-6">
                Nuestra <span className="font-medium text-[#6607a5]">misión</span>
              </h3>
              <p className="text-xl text-gray-700 leading-relaxed italic">
                "El Bienestar no debería ser un logro sino un Derecho Universal. Creemos que cada persona tiene un potencial extraordinario esperando ser descubierto. NEO nació de nuestra pasión por crear un espacio donde la transformación personal sea accesible, auténtica y profundamente significativa para todos."
              </p>
              <div className="flex justify-center mt-8">
                <div className="text-lg text-[#6607a5] font-medium">
                  — Adrián & Diego, Fundadores de NEO
                </div>
              </div>
            </div>
          </div>

          {/* Social Media Section */}
          <div className="text-center mt-16">
            <h3 className="text-2xl font-light text-gray-900 mb-8">
              Síguenos en nuestras <span className="font-medium text-[#6607a5]">redes sociales</span>
            </h3>
            <div className="flex justify-center items-center space-x-8">
              {/* Instagram */}
              <a 
                href="https://www.instagram.com/experiencianeo?igsh=MTh5bWU0YWxmNDVoaw%3D%3D&utm_source=qr" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="group flex flex-col items-center space-y-3 hover:scale-110 transition-all duration-300 cursor-pointer"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-pink-500 to-purple-600 rounded-2xl flex items-center justify-center shadow-lg group-hover:shadow-xl">
                  <i className="ri-instagram-fill text-white text-2xl"></i>
                </div>
                <span className="text-gray-600 font-medium text-sm group-hover:text-[#6607a5] transition-colors">Instagram</span>
              </a>

              {/* TikTok */}
              <a 
                href="https://www.tiktok.com/@experiencianeo" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="group flex flex-col items-center space-y-3 hover:scale-110 transition-all duration-300 cursor-pointer"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-gray-900 to-gray-700 rounded-2xl flex items-center justify-center shadow-lg group-hover:shadow-xl">
                  <i className="ri-tiktok-fill text-white text-2xl"></i>
                </div>
                <span className="text-gray-600 font-medium text-sm group-hover:text-[#6607a5] transition-colors">TikTok</span>
              </a>

              {/* YouTube */}
              <a 
                href="https://www.youtube.com/watch?v=nlk4_B4a57I" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="group flex flex-col items-center space-y-3 hover:scale-110 transition-all duration-300 cursor-pointer"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-red-500 to-red-600 rounded-2xl flex items-center justify-center shadow-lg group-hover:shadow-xl">
                  <i className="ri-youtube-fill text-white text-2xl"></i>
                </div>
                <span className="text-gray-600 font-medium text-sm group-hover:text-[#6607a5] transition-colors">YouTube</span>
              </a>

              {/* Spotify */}
              <a 
                href="https://open.spotify.com/episode/3xQ4UeOYvdCuQfeTg1JGJn?si=XGRrhmS3RB-l9NwpPGrazA" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="group flex flex-col items-center space-y-3 hover:scale-110 transition-all duration-300 cursor-pointer"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-green-600 rounded-2xl flex items-center justify-center shadow-lg group-hover:shadow-xl">
                  <i className="ri-spotify-fill text-white text-2xl"></i>
                </div>
                <span className="text-gray-600 font-medium text-sm group-hover:text-[#6607a5] transition-colors">Spotify</span>
              </a>

            </div>
          </div>

        </div>

      </div>
    </section>
  );
}
